var art_img;
if (window.innerWidth <= 768) {
  // Mobile
  art_img = document.querySelector(".media");
} else {
  // Desktop
  art_img = document.querySelector(".new-pdp .new-pdp-inner");
}

// var appmountBlock = document.querySelector('.shopify-app-block')
var mountBlock = document.querySelector('.mount-block')

var woodDetails =  document.querySelector(".wooden-details");
var metalDetails =  document.querySelector(".metal-details");
var paperDetails =  document.querySelector(".paper-details");
var bgImage =  document.querySelector(".bg-image");
// var metalDetails =  document.querySelector(".metal-details");

//console.log("bundle_frame: 1");
//const bundle_frame = document.querySelectorAll(".picky-option__dropdown  select *");
///bundle_frame.forEach(function() {
//var bundle_frame_data =  el.value.trim();
//  console.log('test_row');
//});
//console.log("bundle_frame: 2");




changeFrame = (e) => {

  //Commented this code because of gift card erorr
  // var frameOption = document.querySelector('input[name="frame_type-1"]:checked').value.trim();
  // frameOption = frameOption.replace(/\s+/g, '');
  // frameOption = frameOption.toLowerCase();
  
  // var sizeOption = document.querySelector('input[name*="product_size-"]:checked').value.trim();
  // sizeOption = sizeOption.replace(/\s+/g, '');
  // sizeOption = sizeOption.toLowerCase();

  var frameInput = document.querySelector('input[name="frame_type-1"]:checked');
  var sizeInput  = document.querySelector('input[name*="product_size-"]:checked');

  var frameOption = frameInput ? frameInput.value.trim() : '';
  frameOption = frameOption.replace(/\s+/g, '').toLowerCase();

  var sizeOption = sizeInput ? sizeInput.value.trim() : '';
  sizeOption = sizeOption.replace(/\s+/g, '').toLowerCase();
  
  // var colorOption = document.querySelector('input[name="frame_color-3"]:checked').value.trim();
  // colorOption = colorOption.replace(/\s+/g, '');
  // colorOption = colorOption.toLowerCase();
  var colorOption = "none";

  showFrameImage(frameOption)
  // CSS shadow changes
  if( (frameOption != "print" && frameOption != "printonly") && (frameOption != "canvas" && frameOption != "canvasonly") ){
    art_img.classList.add("show-in-shadow")
  }else{
    art_img.classList.remove("show-in-shadow");
  }
  if(e.value.trim() == "printonly" || e.value.trim() == "print"){
    intoPrint(frameOption, colorOption)
    
  }
  art_img.dataset.frame = frameOption+"-"+colorOption;
  // frame type changes
  if(e.name.trim() == "frame_type-1"){
    // showText()
    if(frameOption == 'printonly' || frameOption == 'print' || frameOption == "canvas" || frameOption == "canvasonly")
    {
      defaultMount('printonly')
    }else{
      defaultMount('withmount')
    }
   
    //not used
    //set default frame color
    // defaultFrameColor(frameOption)
    console.log(
      "frame: " + frameOption +" size: "+ sizeOption +" color: "
    );
  } 
  // not used
  // frame color changes
  // else if(e.name.trim() == "frame_color-3"){
  //   art_img.dataset.frame = frameOption+"-"+colorOption;

  // }
  defaultSize(frameOption)
  toggleMountBlock(frameOption)
}

showFrameImage = (frame) => {
  const els = document.querySelectorAll(".dynamic-frame")
  els.forEach(function(el) {
     // .visually-hidden messed up the index
    el.classList.add('visually-hidden')
  });
  const els_wall = document.querySelectorAll(".dynamic-frame-wall")
  els_wall.forEach(function(el) {
     // .visually-hidden messed up the index
    el.classList.add('hidden')
  });
  // const el2 = document.querySelectorAll(".bg-image")
  // el2.forEach(function(el) {
  //    el.classList.add('hidden')
  // });

  if(frame == 'canvasonly' || frame == 'canvas') {
     // .visually-hidden messed up the index
    document.querySelector('.canvas-frame-image')?.classList.remove('visually-hidden')
    document.querySelector('.canvas-frame-image-wall')?.classList.remove('hidden')

    woodDetails?.classList.add('hidden')
    metalDetails?.classList.add('hidden')
    paperDetails?.classList.remove('hidden')
  }
  if(frame == 'printonly' || frame == 'print') {
    document.querySelector('.print-frame-image')?.classList.remove('visually-hidden')
    document.querySelector('.print-frame-image-wall')?.classList.remove('hidden')

    woodDetails?.classList.add('hidden')
    metalDetails?.classList.add('hidden')
    paperDetails?.classList.remove('hidden')

  }
  if(frame == 'blackframe' || frame == 'blackwood') {
    document.querySelector('.blackwood-frame-image')?.classList.remove('visually-hidden')
    document.querySelector('.blackwood-frame-image-wall')?.classList.remove('hidden')
    

    woodDetails?.classList.remove('hidden')
    metalDetails?.classList.add('hidden')
    paperDetails?.classList.add('hidden')

    // const el3 = document.querySelectorAll(".bg-image")
    // el3.forEach(function(el) {
    //   el.classList.remove('hidden')
    // });
  }
  if(frame == 'whiteframe' || frame == 'whitewood') {
    document.querySelector('.whitewood-frame-image')?.classList.remove('visually-hidden')
    document.querySelector('.whitewood-frame-image-wall')?.classList.remove('hidden')

    woodDetails?.classList.remove('hidden')
    metalDetails?.classList.add('hidden')
    paperDetails?.classList.add('hidden')
  }
  if(frame == 'oakframe' || frame == 'oakwood') {
    document.querySelector('.oakwood-frame-image')?.classList.remove('visually-hidden')
    document.querySelector('.oakwood-frame-image-wall')?.classList.remove('hidden')

    woodDetails?.classList.remove('hidden')
    metalDetails?.classList.add('hidden')
    paperDetails?.classList.add('hidden')
  }
  if(frame == 'walnutframe' || frame == 'walnutwood') {
    document.querySelector('.walnutwood-frame-image')?.classList.remove('visually-hidden')
    document.querySelector('.walnutwood-frame-image-wall')?.classList.remove('hidden')

    woodDetails?.classList.remove('hidden')
    metalDetails?.classList.add('hidden')
    paperDetails?.classList.add('hidden')
  }
  if(frame == 'blackmetal') {
    document.querySelector('.blackmetal-frame-image')?.classList.remove('visually-hidden')
    document.querySelector('.blackmetal-frame-image-wall')?.classList.remove('hidden')

    woodDetails?.classList.add('hidden')
    metalDetails?.classList.remove('hidden')
    paperDetails?.classList.add('hidden')
  }
  if(frame == 'goldmetal') {
    document.querySelector('.goldmetal-frame-image')?.classList.remove('visually-hidden')
    document.querySelector('.goldmetal-frame-image-wall')?.classList.remove('hidden')

    woodDetails?.classList.add('hidden')
    metalDetails?.classList.remove('hidden')
    paperDetails?.classList.add('hidden')
  }
  if(frame == 'naturalwood' || frame == 'naturalframe') {
    document.querySelector('.naturalwood-frame-image')?.classList.remove('visually-hidden')
    document.querySelector('.naturalwood-frame-image-wall')?.classList.remove('hidden')
    
    woodDetails?.classList.remove('hidden')
    metalDetails?.classList.add('hidden')
    paperDetails?.classList.add('hidden')
  }
  
}

toggleMountBlock = (frameoption) => {
  let frameOption = frameoption;
  frameOption = frameOption.replace(/\s+/g, '');
  frameOption = frameOption.toLowerCase();

}

intoPrint = (frameOption, colorOption) => {
  art_img.classList.remove("wooden-frame-black");
  // art_img.classList.remove("show-in-shadow");
  art_img.dataset.frame = frameOption+"-"+colorOption;
  art_img.dataset.mount = 'printonly';
}

initializeMount = (frame_option, size_option, color_option) => {
  // var frameOption = frame_option;
  var sizeOption = size_option;
  var colorOption = color_option;

  // for property type mount
  const els = document.getElementsByClassName("input-mount")
  for (const el of els) {
    el.addEventListener("change", (e)=> {
      let frameOption = document.querySelector('input[name="frame_type-1"]:checked').value.trim().replace(/\s+/g, '').toLowerCase();

      let mount = e.target.value.replace(/\s+/g, '').trim().replace(/\s+/g, '').toLowerCase();

      if(frameOption == "print" ||  frameOption == "printonly" ||  frameOption == "canvas" || frameOption == "canvasonly") {
        mount = "nomount";
      }
      art_img.dataset.mount = mount

    })

  }

}

changeMount = (e) => {

  let frameOption = document.querySelector('input[name="frame_type-1"]:checked').value.trim().replace(/\s+/g, '').toLowerCase();
  let mount = e.value.replace(/\s+/g, '').trim().replace(/\s+/g, '').toLowerCase();
  if(frameOption == "print" || frameOption == "printonly" ||  frameOption == "canvas" || frameOption == "canvasonly") {
    mount = "withmount";
  }
  
  if(mount == 'nomount'){
    defaultSize(frameOption, false)
  }else{
    defaultSize(frameOption, true)
  }
  
  art_img.dataset.mount = mount

}

defaultMount = (defaultMount) => {
  let frameOption = document.querySelector('input[name="frame_type-1"]:checked').value.trim().replace(/\s+/g, '').toLowerCase();
  if(frameOption == 'canvasonly' || frameOption == 'blackframe' || frameOption == 'whiteframe' || frameOption == 'naturalframe'){

  }else{
    const els = document.getElementsByClassName("input-mount")
    let nomount = els[1]
    let withmount = els[0]
    if(defaultMount == 'nomount' || defaultMount == 'printonly' || defaultMount == 'print'){
      nomount.checked = true;
      withmount.checked = false;
    }else{
      nomount.checked = false;
      withmount.checked = true;
    }
    art_img.dataset.mount = defaultMount
  }

}
defaultSize = (frameOption, withMount = true) => {
  // let frameOption = document.querySelector('input[name="frame_type-1"]:checked').value.trim().replace(/\s+/g, '').toLowerCase();
    const woodDefault = document.querySelector('input[value="30x40"]')
    const woodDefaultSqr = document.querySelector('input[value="36x36"]')
    const woodDefaultNoMount = document.querySelector('input[value="28x40"]')

    const metalDefault = document.querySelector('input[value="27.5x37.5"]')
    const metalDefaultSqr = document.querySelector('input[value="33.5x33.5"]')
    const metalDefaultNoMount = document.querySelector('input[value="25.5x37.5"]')

    const printDefault = document.querySelector('input[value="20x30"]')
    const printDefaultSqr = document.querySelector('input[value="36x36"]')

    const canvasDefault = document.querySelector('input[value="30x45"]')
    const canvasDefaultSqr = document.querySelector('input[value="36x36"]')

    const canvasFrameDefault = document.querySelector('input[value="35x50"]')
    const canvasFrameDefaultSqr = document.querySelector('input[value="41x41"]')
    
    const productOrientation = document.querySelector("#current_product_orientation")
 
    if(frameOption == 'canvasonly' || frameOption == 'canvas'){
      if(productOrientation.value == 'square'){
        canvasDefaultSqr.checked = true;
      }else{
        canvasDefault.checked = true;
      }
      
    }
    if(frameOption == 'printonly' || frameOption == 'print'){
      if(productOrientation.value == 'square'){
        printDefaultSqr.checked = true;
      }else{
        printDefault.checked = true;
      }
      
    }
    if(frameOption == 'blackmetal' || frameOption == 'goldmetal'){
      if(withMount){
        if(productOrientation.value == 'square'){
          metalDefaultSqr.checked = true;
        }else{
          metalDefault.checked = true;
        }
        
      }else{
        if(productOrientation.value == 'square'){
          metalDefaultSqr.checked = true;
        }else{
          metalDefaultNoMount.checked = true;
        }
      }
      
    }
    if(frameOption == 'blackwood' || frameOption == 'whitewood' || frameOption == 'oakwood' || frameOption == 'walnutwood' || frameOption == 'naturalwood') {
      if(withMount){
        if(productOrientation.value == 'square'){
          woodDefaultSqr.checked = true;
        }else{
          woodDefault.checked = true;
        }
        
      }else{
        if(productOrientation.value == 'square'){
          woodDefaultSqr.checked = true;
        }else{
          woodDefaultNoMount.checked = true;
        }
        
      }
    
    }
    if(frameOption == 'blackframe' || frameOption == 'whiteframe' || frameOption == 'oakframe' || frameOption == 'walnutframe' || frameOption == 'naturalframe') {
      if(productOrientation.value == 'square'){
        canvasFrameDefaultSqr.checked = true;
      }else{
        canvasFrameDefault.checked = true;
      }
    }
}

// defaultFrameColor = (frame_option) => {
//   let frameOption = frame_option;
//   if(frameOption == "blackframe" || frameOption == "metalframe" ){
//     var colorOption2 = document.querySelector('input[value="black"]')
//     art_img.dataset.frame = frameOption+"-black";
//     colorOption2.checked = true;
//   }else{
//     var colorOption2 = document.querySelector('input[value="none"]')
//     // art_img.dataset.frame = frameOption+"-"+colorOption;
//     art_img.dataset.frame = frameOption+"-none";
//     colorOption2.checked = true;
//   }
// }



function showText() {
    var transitionTime = 3250;
    var faderTimeout = null; // keep track of this to cancel it if multiple events happen
    var fadeText = document.getElementById("size-info");

    fadeText.classList.remove('show');   
    fadeText.classList.add('show');

    window.clearTimeout(faderTimeout);

    faderTimeout = window.setTimeout(() => {
      fadeText.classList.remove('show');
    }, transitionTime);
}

initialBuilder = function initialBuilder() {

  
  // artwork = document.querySelector("#art-container");
  frameOption = document.querySelector('input[name="frame_type-1"]:checked')?.value.trim();
  frameOption = frameOption.replace(/\s+/g, '');
  frameOption = frameOption.toLowerCase();

  sizeOption = document.querySelector('input[name*="product_size-"]:checked')?.value.trim();
  sizeOption = sizeOption.replace(/\s+/g, '');
  sizeOption = sizeOption.toLowerCase();

  // colorOption = document.querySelector('input[name="frame_color-3"]:checked').value.trim();
  // colorOption = colorOption.replace(/\s+/g, '');
  // colorOption = colorOption.toLowerCase();
  colorOption = "none"

  console.log(
    "frame: " + frameOption +" size: "+ sizeOption +" color: "+colorOption
  );
  if( (frameOption != "printonly" && frameOption != "print") && (frameOption != 'canvas' && frameOption != 'canvasonly')){
    art_img.classList.add("show-in-shadow")
  }
 
  toggleMountBlock(frameOption)
  initializeMount(frameOption, sizeOption, colorOption)
  showFrameImage(frameOption)

  if(frameOption == "print" ||  frameOption == "printonly" ||  frameOption == "canvas" || frameOption == "canvasonly" || frameOption == "blackframe" || frameOption == "whiteframe" || frameOption == "naturalframe") {
    mount = "nomount";
  }else{
    mount = "withmount";
  }
  art_img.dataset.mount = mount

  art_img.dataset.frame = frameOption+"-"+colorOption;
 
};

function hideMountOption() {
  const mount_option =  document.querySelector(".mount-option");
  frameOption = document.querySelector('input[name="frame_type-1"]:checked')?.value.trim();
  frameOption = frameOption?.replace(/\s+/g, '');
  frameOption = frameOption?.toLowerCase();

  if(frameOption == "print" ||  frameOption == "printonly" ||  frameOption == "canvas" || frameOption == "canvasonly") {
    mount_option?.classList.add("hidden")
  }

}
hideMountOption()
initialBuilder();

function intel() {
  console.log('1v')
}

function updatePopUpVisibility() {
  const frameInput = document.querySelector('input[name="frame_type-1"]:checked');
  const frameOption = frameInput ? frameInput.value.trim().replace(/\s+/g, '').toLowerCase() : '';
  const popup = document.querySelector('.trigger-pop-up');

  if (!popup) return;

  if (['goldmetal', 'blackmetal', 'printonly', 'print'].includes(frameOption)) {
    popup.style.display = 'none';
  } else {
    popup.style.display = '';
  }
}

// Call once on page load
updatePopUpVisibility();

// Event delegation for dynamic inputs (AJAX)
document.addEventListener('change', function(e) {
  if (e.target.matches('input[name="frame_type-1"]')) {
    updatePopUpVisibility();
  }
});

